import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase/config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faFileAlt, 
  faUsers, 
  faSignOutAlt,
  faFilePdf,
  faCog,
  faHome,
  faChartLine
} from '@fortawesome/free-solid-svg-icons';
import '../../styles/components/layout/NavbarStyles.css';

function Navbar({ user }) {
  useEffect(() => {
    const handleResize = () => {
      // Responsive functionality if needed
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

  return (
    <nav className="nav-container">
      <div className="nav-left">
        <div className="logo-container">
          <img src="/App/logos/logo-navbar.png" alt="AMS Logo" className="nav-logo" />
        </div>
        <div className="nav-links">
          {user?.rol === 'admin' ? (
            <>
              <Link to="/dashboard" className="nav-link">
                <FontAwesomeIcon icon={faHome} className="nav-icon" />
                <span>Inicio</span>
              </Link>
              <Link to="/generar-pdf" className="nav-link">
                <FontAwesomeIcon icon={faFilePdf} className="nav-icon" />
                <span>Generar PDF</span>
              </Link>
              <Link to="/certificados" className="nav-link">
                <FontAwesomeIcon icon={faCog} className="nav-icon" />
                <span>Gestión de Certificados</span>
              </Link>
              <Link to="/usuarios" className="nav-link">
                <FontAwesomeIcon icon={faUsers} className="nav-icon" />
                <span>Gestión de Usuarios</span>
              </Link>
              {/* <Link to="/metricas" className="nav-link">
                <FontAwesomeIcon icon={faChartLine} className="nav-icon" />
                <span>Métricas BDD</span>
              </Link> */}
            </>
          ) : (
            <>
              <Link to="/dashboard" className="nav-link">
                <FontAwesomeIcon icon={faHome} className="nav-icon" />
                <span>Inicio</span>
              </Link>
              <Link to="/historial" className="nav-link">
                <FontAwesomeIcon icon={faFileAlt} className="nav-icon" />
                <span>Mis Certificados</span>
              </Link>
            </>
          )}
        </div>
      </div>

      <div className="user-box">
        <div className="user-info">
          <span className="user-name">{user?.nombre}</span>
          <span className="user-empresa">{user?.empresa}</span>
        </div>
        <button className="logout-button" onClick={handleLogout}>
          <FontAwesomeIcon icon={faSignOutAlt} />
          <span>Cerrar sesión</span>
        </button>
      </div>
    </nav>
  );
}

export default Navbar;
